import { motion } from "framer-motion";
import { GlowOrb, Eyebrow } from "./primitives";

export default function PageHeader({ eyebrow, title, sub, testid = "page-header" }) {
  return (
    <section data-testid={testid} className="relative overflow-hidden pb-14 pt-36 lg:pb-20 lg:pt-44">
      <GlowOrb className="left-1/2 top-0 h-[360px] w-[600px] -translate-x-1/2 opacity-20" color="#FF5A36" />
      <div
        className="absolute inset-0 -z-10 opacity-[0.05]"
        style={{ backgroundImage: "radial-gradient(circle at 1px 1px, #fff 1px, transparent 0)", backgroundSize: "32px 32px" }}
      />
      <div className="mx-auto max-w-3xl px-5 text-center lg:px-8">
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
          <Eyebrow>{eyebrow}</Eyebrow>
        </motion.div>
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.08 }}
          className="mt-6 font-heading text-4xl font-semibold leading-[1.1] text-white sm:text-5xl lg:text-6xl"
        >
          {title}
        </motion.h1>
        {sub && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.16 }}
            className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg"
          >
            {sub}
          </motion.p>
        )}
      </div>
    </section>
  );
}
